import { useSelector } from "store";
import { appInsights } from "../utils/ApplicationInsightsService";

export const useKnowledgeBaseTracker = () => {
  const { activeUser } = useSelector((state) => state.user);
  const { selectedClient } = useSelector((state) => state.customer);

  const trackKnowledgeBaseView = () => {
    appInsights.trackEvent(
      { name: "[KnowledgeBasePageView]" },
      {
        userId: activeUser?.userId,
        userType: activeUser?.type,
        userDomain: activeUser?.domain,
        clientName: selectedClient?.name,
      },
    );
  };

  return { trackKnowledgeBaseView };
};
